import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import { useRouteMatch } from 'react-router-dom'
import { apiGetPresentation } from '../../../common/api/lesson'
import usePresentationPrint from '../../use-presentation-print/use-presentation-print'

const styles = {}

const PrintPreview = injectSheet(styles)(({ classes }) => {
  const [presentation, setPresentation] = useState(null)

  const { print, PrintComponent } = usePresentationPrint(presentation, {
    test: true
  })

  const match = useRouteMatch()
  const id = match.params.id

  useEffect(
    () => {
      if (id) {
        apiGetPresentation(id, {
          include:
            'presentation.asset,presentation.lesson,presentation.account.names,presentation.account.avatar,presentation.names,presentation.image,presentation.details,presentation.slides,presentation.slide.details,presentation.slide.type,presentation.year_groups,presentation.year_group.order,presentation.recommended_until,presentation.category,presentation.flag.data'
        })
          .then(res => {
            setPresentation(res.data.presentation)
            print()
          })
          .catch()
      }
    },
    [id] // eslint-disable-line
  )

  return (
    <div>
      <PrintComponent />
    </div>
  )
})

export default PrintPreview
